/**
 * Role-aware dashboard destination when leaving live training.
 */
export function resolveDashboardPath(user) {
  if (!user) return "/home";
  const isAdminType = user.type_user_id === 1 || user.type_user_id === 2;
  let hasAdminRole = false;
  if (Array.isArray(user.all_role_names)) {
    hasAdminRole =
      user.all_role_names.includes("Admin") ||
      user.all_role_names.includes("Super Admin");
  } else if (Array.isArray(user.all_roles)) {
    hasAdminRole = user.all_roles.includes("r2") || user.all_roles.includes("r1");
  }
  if (user.isSuperAdmin || isAdminType || hasAdminRole || user.hasAdminRole) {
    return "/Dashboard";
  }
  return "/home";
}
